import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/components/VersionStatusSwitch/VersionStatusSwitch.tsx";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.is-array.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { Triangle } from '@gmini/ui-kit';
import { CircularProgress } from '@gmini/ui-kit/lib/CircularProgress';
import { Popover } from '@mui/material';
import React from 'react';
import { Positive, PopoverText, PopoverStatusItem, VersionStatusSwitchButton, PopoverContent, StatusLabel, Wrapper } from "./VersionStatusSwitch.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var VersionStatusSwitch = function VersionStatusSwitch(_ref) {
  var onChangeStatus = _ref.onChangeStatus,
      disabled = _ref.disabled,
      currentStatus = _ref.currentStatus,
      loading = _ref.loading;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var handleClose = React.useCallback(function () {
    setAnchorEl(null);
  }, []);
  var open = Boolean(anchorEl);
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsx(Popover, {
      open: open,
      anchorEl: anchorEl,
      onClose: handleClose,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      children: /*#__PURE__*/_jsx(PopoverContent, {
        children: optionList.map(function (item) {
          return /*#__PURE__*/_jsxs(PopoverStatusItem, {
            onClick: function onClick() {
              setAnchorEl(null);
              onChangeStatus === null || onChangeStatus === void 0 ? void 0 : onChangeStatus(item.status);
            },
            children: [item.icon, /*#__PURE__*/_jsx(PopoverText, {
              children: item.name
            })]
          }, item.status);
        })
      })
    }), /*#__PURE__*/_jsxs(VersionStatusSwitchButton, {
      disabled: disabled || loading,
      onClick: function onClick(event) {
        return setAnchorEl(event.currentTarget);
      },
      children: [/*#__PURE__*/_jsx(StatusLabel, {
        children: statusMapDesc[currentStatus]
      }), loading ? /*#__PURE__*/_jsx(CircularProgress, {
        size: 8
      }) : /*#__PURE__*/_jsx(Triangle, {
        color: disabled ? 'rgba(53, 59, 96, 0.2)' : '#353B60',
        width: "8px",
        height: "8px"
      })]
    })]
  });
};
export var optionList = [{
  name: 'Опубликовать',
  status: 'PUBLISHED',
  icon: /*#__PURE__*/_jsx(Positive, {})
}];
export var statusMapDesc = {
  DRAFT: 'ДРАФТ',
  PUBLISHED: 'ОПУБЛИКОВАНО'
};